import {
  Users, GraduationCap, MapPin, Calendar, Settings, DollarSign, Receipt,
  BarChart3, Upload, LayoutGrid, Laptop, UsersRound, Settings2, CreditCard,
  UserCheck, Calculator, Wallet, CalendarCheck, Mail, Building2, Search, Music,
  Globe, History, Shield, MessageSquare, Inbox, ClipboardCheck, Video, Landmark,
  PenLine, BookOpen, Briefcase, FileText,
} from 'lucide-react';

/**
 * Hierarchical left sidebar.
 * Leaf `id` is stable (stored in tenant.sidebar_menu.hidden).
 * Groups are UI-only (not tenant-configurable).
 * Items with `superAdminOnly` are never tenant-configurable.
 */

/** Flat leaf items (legacy shape) — used by group children */
const L = (item) => ({ type: 'link', ...item });

export const SIDEBAR_NAVIGATION = [
  L({ id: 'start', name: 'Startfenster', href: '/', icon: LayoutGrid }),

  {
    type: 'group',
    id: 'group-unterricht',
    name: 'Unterricht',
    icon: Laptop,
    children: [
      L({ id: 'unterrichtsverwaltung', name: 'Unterrichtsverwaltung', href: '/unterrichtsverwaltung', icon: Laptop, resource: 'enrollments', hideForTeacher: true }),
      L({ id: 'calendar', name: 'Kalender', href: '/calendar', icon: Calendar }),
      L({ id: 'registrations-inbox', name: 'Online-Anmeldungen', href: '/registrations-inbox', icon: Globe, resource: 'enrollments' }),
      L({ id: 'contract-declarations', name: 'Kündigung und Widerruf', href: '/kuendigung-widerruf', icon: FileText, resource: 'enrollments' }),
      L({ id: 'anwesenheitslisten', name: 'Anwesenheitslisten', href: '/anwesenheitslisten', icon: ClipboardCheck, resource: 'lessons' }),
      L({ id: 'courses', name: 'Kurse', href: '/courses', icon: BookOpen, resource: 'courses' }),
      L({ id: 'free-slots', name: 'Freie Plätze', href: '/free-slots', icon: UsersRound, resource: 'courses', hideForTeacher: true }),
      L({ id: 'trial-lessons', name: 'Probestunden', href: '/trial-lessons', icon: CalendarCheck, resource: 'lessons' }),
    ],
  },

  {
    type: 'group',
    id: 'group-personen',
    name: 'Personen',
    icon: Users,
    children: [
      L({ id: 'students', name: 'Schüler', href: '/students', icon: Users, resource: 'students' }),
      L({ id: 'families', name: 'Familien', href: '/families', icon: UsersRound, resource: 'families', hideForTeacher: true }),
      L({ id: 'teachers', name: 'Lehrer', href: '/teachers', icon: GraduationCap, resource: 'teachers' }),
      L({ id: 'guardians', name: 'Zahlungspflichtige', href: '/guardians', icon: UserCheck, resource: 'payers' }),
      L({ id: 'payer-accounts', name: 'Zahlungspflichtige', href: '/payer-accounts', icon: Landmark, resource: 'payers' }),
      L({ id: 'family-moves', name: 'Mandanten-Umzüge', href: '/family-moves', icon: History, resource: 'tenant_moves' }),
      L({ id: 'self-service-inbox', name: 'Self-Service-Inbox', href: '/self-service-inbox', icon: Inbox, resource: 'enrollments' }),
    ],
  },

  {
    type: 'group',
    id: 'group-raeume',
    name: 'Standorte & Räume',
    icon: MapPin,
    children: [
      L({ id: 'locations', name: 'Standorte & Räume', href: '/locations', icon: MapPin, resource: 'locations', hideForTeacher: true }),
      L({ id: 'room-finder', name: 'Raumfinder', href: '/room-finder', icon: Search, resource: 'locations' }),
    ],
  },

  {
    type: 'group',
    id: 'group-abrechnungen',
    name: 'Abrechnungen',
    icon: Calculator,
    children: [
      L({ id: 'tariffs-discounts', name: 'Gebührenverwaltung', href: '/tariffs-discounts', icon: DollarSign, anyResource: ['tariffs', 'discounts'] }),
      L({ id: 'invoices', name: 'Rechnungen', href: '/invoices', icon: Receipt, resource: 'invoices' }),
      L({ id: 'billing-preview', name: 'Rechnungslauf-Vorschau', href: '/billing-preview', icon: Calculator, resource: 'billing' }),
      L({ id: 'sepa', name: 'Zahlungsverkehr', href: '/sepa', icon: CreditCard, resource: 'sepa' }),
      L({ id: 'fixed-amounts', name: 'Fixbeträge', href: '/fixed-amounts', icon: Calculator, resource: 'fixed_amounts' }),
      L({ id: 'prepaid-cards', name: 'Prepaid-Karten', href: '/prepaid-cards', icon: Wallet, resource: 'prepaid_cards' }),
      L({ id: 'instrument-rental', name: 'Instrumentenvermietung', href: '/instrument-rental', icon: Music, resource: 'instruments', hideForTeacher: true }),
      L({ id: 'payroll', name: 'Honorare & Gehälter', href: '/payroll', icon: CreditCard, resource: 'billing' }),
    ],
  },

  {
    type: 'group',
    id: 'group-statistiken',
    name: 'Statistiken',
    icon: BarChart3,
    children: [
      L({ id: 'reports', name: 'Reports', href: '/reports', icon: BarChart3, resource: 'reports' }),
      L({ id: 'gkz-auswertung', name: 'GKZ-Auswertung', href: '/gkz-auswertung', icon: MapPin, resource: 'reports' }),
    ],
  },

  {
    type: 'group',
    id: 'group-kommunikation',
    name: 'Kommunikation',
    icon: Mail,
    children: [
      L({ id: 'messages', name: 'Nachrichten', href: '/nachrichten', icon: MessageSquare, resource: 'messages', showUnreadBadge: true }),
      L({ id: 'conferences', name: 'Konferenzen', href: '/conferences', icon: Video }),
      L({ id: 'email', name: 'E-Mail', href: '/email', icon: Mail }),
      L({ id: 'correspondence', name: 'Korrespondenz', href: '/correspondence', icon: PenLine }),
      L({ id: 'mail-approval', name: 'E-Mail-Freigabe', href: '/mail-approval', icon: Mail, superAdminOnly: true, showMailApprovalBadge: true }),
    ],
  },

  {
    type: 'group',
    id: 'group-konfiguration',
    name: 'Konfiguration',
    icon: Settings,
    children: [
      L({ id: 'stammdaten', name: 'Stammdaten', href: '/stammdaten', icon: Settings2, resource: 'stammdaten', hideForTeacher: true }),
      L({ id: 'settings', name: 'Einstellungen', href: '/settings', icon: Settings, resource: 'settings', hideForTeacher: true }),
      L({ id: 'msv-import', name: 'MSV Import', href: '/msv-import', icon: Upload, resource: 'imports', roles: ['admin', 'secretary', 'sekretariat', 'verwaltung'] }),
      L({ id: 'filemaker-import', name: 'FileMaker-Import', href: '/filemaker-import', icon: Upload, resource: 'imports', roles: ['admin', 'secretary', 'sekretariat', 'verwaltung'] }),
    ],
  },

  {
    type: 'group',
    id: 'group-system',
    name: 'System',
    icon: Briefcase,
    children: [
      L({ id: 'zentrale', name: 'Zentrale', href: '/zentrale', icon: Building2, roles: ['admin'] }),
      L({ id: 'tenants', name: 'Mandanten', href: '/tenants', icon: Building2, superAdminOnly: true }),
      L({ id: 'benutzerverwaltung', name: 'Benutzerverwaltung', href: '/benutzerverwaltung', icon: Shield, superAdminOnly: true }),
      L({ id: 'overview', name: 'Mandanten-Übersicht', href: '/overview', icon: Globe, superAdminOnly: true }),
    ],
  },
];

/** Flatten all leaf link items (for filtering / tenant config). */
export function flattenSidebarLinks(items = SIDEBAR_NAVIGATION) {
  const out = [];
  for (const item of items) {
    if (item.type === 'group') out.push(...flattenSidebarLinks(item.children || []));
    else if (item.type === 'link' || item.href) out.push(item);
  }
  return out;
}

/** Items s-admin may show/hide per tenant (excludes superAdminOnly). */
export const CONFIGURABLE_SIDEBAR_ITEMS = flattenSidebarLinks()
  .filter((item) => !item.superAdminOnly)
  .map(({ id, name }) => ({ id, name }));

export const CONFIGURABLE_SIDEBAR_IDS = new Set(
  CONFIGURABLE_SIDEBAR_ITEMS.map((i) => i.id),
);
